[data-react-route-map-panel="true"] .route-stage__map-shell {
  position: relative;
  isolation: isolate;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--line);
  background: #f9fafb;
  box-shadow: none;
}

[data-react-route-map-panel="true"] .dispatch-map-shell {
  height: clamp(320px, calc(48vh - 60px), 500px);
  min-height: clamp(320px, calc(48vh - 60px), 500px);
}

[data-react-route-map-panel="true"] .route-map {
  position: relative;
  z-index: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: clamp(320px, calc(48vh - 60px), 500px);
  min-height: clamp(320px, calc(48vh - 60px), 500px);
  overflow: hidden;
  background: transparent;
}

[data-react-route-map-panel="true"] .route-map.leaflet-container,
[data-react-route-map-panel="true"] .leaflet-container {
  max-width: 100%;
  min-width: 0;
}

[data-react-route-map-panel="true"] .leaflet-container {
  background: #e5efdc;
}

[data-react-route-map-panel="true"] .leaflet-control-attribution {
  max-width: 100%;
  font-size: 8px;
  line-height: 1.4;
  background: rgba(255, 255, 255, 0.9);
}

[data-react-route-map-panel="true"] .leaflet-gl-layer {
  position: absolute;
  pointer-events: none;
}

[data-react-route-map-panel="true"] .leaflet-container .leaflet-tile-pane img,
[data-react-route-map-panel="true"] .leaflet-container img.leaflet-tile,
[data-react-route-map-panel="true"] .leaflet-container .leaflet-tile {
  border: 0 !important;
  box-shadow: none !important;
  max-height: none !important;
  max-width: none !important;
  outline: 0 !important;
}

[data-react-route-map-panel="true"] .leaflet-container img.leaflet-tile {
  mix-blend-mode: normal !important;
}

[data-react-route-map-panel="true"] .route-map__segment {
  transition: stroke-width 140ms ease;
}

[data-react-route-map-panel="true"] .route-map__segment--direction {
  pointer-events: none;
  opacity: 0;
  transition: opacity 220ms ease;
  user-select: none;
}

[data-react-route-map-panel="true"] .route-map__segment--direction.route-map__segment--highlighted {
  opacity: 1;
}

[data-react-route-map-panel="true"] .route-map__segment--direction-arrow path {
  stroke: #ffffff;
  stroke-width: 2.6px;
  filter: drop-shadow(0 0 1px rgba(18, 24, 42, 0.8));
}

[data-react-route-map-panel="true"] .route-map__segment--direction text {
  fill: #ffffff;
  stroke: #12182a;
  stroke-width: 0.8px;
  paint-order: stroke;
  font-size: 10px;
  font-weight: 800;
}

@media (prefers-reduced-motion: reduce) {
  [data-react-route-map-panel="true"] .route-map__segment,
  [data-react-route-map-panel="true"] .route-map__segment--direction {
    transition: none;
  }
}

[data-react-route-map-panel="true"][data-route-map-variant="compact"] .dispatch-map-shell,
[data-react-route-map-panel="true"][data-route-map-variant="compact"] .route-map {
  height: clamp(192px, 22vh, 236px);
  min-height: clamp(192px, 22vh, 236px);
}

[data-react-route-map-panel="true"][data-route-map-variant="compact"] .route-map-legend__row {
  gap: 6px 10px;
}

[data-react-route-map-panel="true"][data-route-map-variant="compact"] .route-map-legend__item,
[data-react-route-map-panel="true"][data-route-map-variant="compact"] .trip-stop-legend__item,
[data-react-route-map-panel="true"][data-route-map-variant="compact"] .route-map-legend__empty {
  font-size: 0.69rem;
}

[data-react-route-map-panel="true"][data-route-map-expanded="true"] .dispatch-map-shell,
[data-react-route-map-panel="true"][data-route-map-expanded="true"] .route-map {
  height: clamp(308px, 34vh, 420px);
  min-height: clamp(308px, 34vh, 420px);
}

[data-react-route-map-panel="true"][data-route-map-floating-size="standard"] .dispatch-map-shell,
[data-react-route-map-panel="true"][data-route-map-floating-size="standard"] .route-map {
  height: clamp(360px, 44vh, 500px);
  min-height: clamp(360px, 44vh, 500px);
}

[data-react-route-map-panel="true"][data-route-map-floating-size="large"] .dispatch-map-shell,
[data-react-route-map-panel="true"][data-route-map-floating-size="large"] .route-map {
  height: clamp(420px, 52vh, 620px);
  min-height: clamp(420px, 52vh, 620px);
}

[data-react-route-map-panel="true"] .route-map__empty {
  position: absolute;
  inset: 18px;
  border-radius: 8px;
  border: 1px dashed var(--line-strong);
  background: #ffffff;
  padding: 20px;
  display: grid;
  align-content: end;
  gap: 8px;
  pointer-events: none;
}

[data-react-route-map-panel="true"] .route-map__empty-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

[data-react-route-map-panel="true"] .route-map__empty strong {
  font-family: "Space Grotesk", "Segoe UI", sans-serif;
  font-size: 1.05rem;
}

[data-react-route-map-panel="true"] .route-map__empty p {
  color: var(--muted);
  line-height: 1.6;
}

[data-react-route-map-panel="true"] .route-map-stop-index {
  background: transparent;
  border: 0;
  pointer-events: auto;
}

[data-react-route-map-panel="true"] .route-map-stop-index__cluster {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transform: translateX(8px);
  pointer-events: auto;
}

[data-react-route-map-panel="true"] .route-map-stop-index__cluster--icon {
  gap: 0;
  transform: none;
}

[data-react-route-map-panel="true"] .route-map-stop-index__cluster--with-house {
  gap: 20px;
  transform: none;
}

[data-react-route-map-panel="true"] .route-map-stop-index__cluster--house-only {
  gap: 0;
  transform: none;
}

[data-react-route-map-panel="true"] .route-map-stop-index__house {
  width: 49px;
  height: 53px;
  background: url("/template-images/house2.png") center / contain no-repeat;
  filter: drop-shadow(0 2px 4px rgba(10, 32, 37, 0.24));
  pointer-events: auto;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge {
  --route-map-stop-badge-background: #12182a;
  --route-map-stop-badge-border: #ffffff;
  --route-map-stop-badge-shadow: none;
  --route-map-stop-badge-eyebrow-color: rgba(255, 255, 255, 0.9);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 18px;
  width: 18px;
  height: 18px;
  padding: 0;
  border-radius: 999px;
  border: 1.5px solid var(--route-map-stop-badge-border);
  background: var(--route-map-stop-badge-background);
  box-shadow: var(--route-map-stop-badge-shadow);
  color: #ffffff;
  font-family: "Space Grotesk", "Segoe UI", sans-serif;
  font-size: 0.66rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  pointer-events: auto;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--icon {
  padding: 0;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--icon-labeled {
  flex-direction: column;
  gap: 0;
  min-width: 68px;
  max-width: 100px;
  min-height: 22px;
  width: auto;
  height: auto;
  padding: 1px 6px 2px;
  border-radius: 11px;
  overflow: hidden;
  white-space: nowrap;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--origin {
  --route-map-stop-badge-background: var(--color-accent);
  --route-map-stop-badge-border: #ffffff;
  --route-map-stop-badge-shadow: none;
  --route-map-stop-badge-eyebrow-color: rgba(240, 253, 250, 0.98);
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--destination {
  --route-map-stop-badge-background: #12182a;
  --route-map-stop-badge-border: #ffffff;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--with-icon {
  justify-content: center;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--textual {
  justify-content: center;
  gap: 1px;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--icon svg {
  width: 13px;
  height: 13px;
  display: block;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--icon-labeled svg {
  width: 14px;
  height: 14px;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge-eyebrow {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--route-map-stop-badge-eyebrow-color);
  font-size: 0.55rem;
  font-weight: 900;
  letter-spacing: 0.01em;
  line-height: 0.95;
  opacity: 0.98;
  text-transform: none;
  white-space: nowrap;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.02;
  text-transform: none;
  white-space: nowrap;
}

[data-react-route-map-panel="true"] .route-map-route-distance-icon {
  background: transparent;
  border: 0;
  display: block;
  height: 0;
  position: relative;
  overflow: visible;
  pointer-events: none;
  width: 0;
}

[data-react-route-map-panel="true"] .route-map-route-distance__pill {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 18px;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  background: rgba(15, 23, 42, 0.92);
  box-shadow: 0 10px 18px rgba(10, 32, 37, 0.18);
  color: #ffffff;
  font-size: 0.56rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 1;
  pointer-events: none;
  white-space: nowrap;
  transform: translate(-50%, -50%);
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--grouped {
  min-width: 32px;
  width: auto;
  height: 20px;
  padding: 0 4px;
  font-size: 0.66rem;
  letter-spacing: 0.01em;
  box-shadow: 0 12px 24px rgba(10, 32, 37, 0.26), 0 0 0 2px rgba(14, 19, 27, 0.16);
}

[data-react-route-map-panel="true"] .route-map-stop-cluster-icon {
  background: transparent;
  border: 0;
  overflow: visible;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__shell {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__shell--with-house {
  overflow: visible;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__house {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 0;
  transform: translate(calc(-50% - 56px), -12px);
  pointer-events: none;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__bubble {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 999px;
  border: 1.5px solid #ffffff;
  background: #12182a;
  box-shadow: 0 1px 3px rgba(18, 24, 42, 0.2);
  pointer-events: none;
  z-index: 2;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__bubble-dots {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__bubble-dots span {
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__preview {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(calc(-50% + var(--cluster-preview-x, 0px)), calc(-50% + var(--cluster-preview-y, 0px)));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 18px;
  width: auto;
  height: 18px;
  padding: 0 1px;
  border-radius: 999px;
  border: 1.5px solid #ffffff;
  background: var(--color-accent);
  box-shadow: 0 1px 3px rgba(18, 24, 42, 0.2);
  color: #ffffff;
  font-family: "Plus Jakarta Sans", "Segoe UI", sans-serif;
  font-size: 0.6rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  white-space: nowrap;
  pointer-events: auto;
  cursor: help;
  -webkit-font-smoothing: antialiased;
  text-rendering: geometricPrecision;
  z-index: 1;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--loading {
  --route-map-stop-badge-background: #5f86b8;
}

[data-react-route-map-panel="true"] .route-map-stop-index__badge--delivery {
  --route-map-stop-badge-background: #b09256;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__preview--loading {
  background: #5f86b8;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__preview--delivery {
  background: #b09256;
}

[data-react-route-map-panel="true"] .route-map-stop-cluster__preview--overflow {
  background: #12182a;
  border-color: #ffffff;
  color: #ffffff;
}

[data-react-route-map-panel="true"] .route-map-legend {
  display: grid;
  min-width: 0;
  max-width: 100%;
  gap: 6px;
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] {
  gap: 4px;
}

[data-react-route-map-panel="true"] .route-map-legend__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  gap: 8px 14px;
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .route-map-legend__row {
  flex-wrap: wrap;
  gap: 4px 8px;
}

[data-react-route-map-panel="true"] .route-map-legend__label {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted-strong);
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .route-map-legend__label {
  font-size: 0.56rem;
  letter-spacing: 0.1em;
}

[data-react-route-map-panel="true"] .route-map-legend__label--points {
  margin-left: 8px;
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .route-map-legend__label--points {
  margin-left: 4px;
}

[data-react-route-map-panel="true"] .route-map-legend__items {
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  max-width: 100%;
  gap: 8px 12px;
  align-items: center;
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .route-map-legend__items {
  flex-wrap: wrap;
  gap: 4px 6px;
}

[data-react-route-map-panel="true"] .route-map-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--muted-strong);
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .route-map-legend__item {
  gap: 5px;
  font-size: 0.64rem;
}

[data-react-route-map-panel="true"] .route-map-legend__swatch {
  flex: 0 0 auto;
  --route-segment-color: var(--color-accent);
}

[data-react-route-map-panel="true"] .route-map-legend__swatch--route {
  width: 30px;
  height: 0;
  border-top: 4px solid var(--route-segment-color);
  border-radius: 999px;
  box-shadow: 0 0 0 2px #000000;
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .route-map-legend__swatch--route {
  width: 20px;
  border-top-width: 3px;
  box-shadow: 0 0 0 1.5px #000000;
}

[data-react-route-map-panel="true"] .route-map-legend__empty {
  font-size: 0.74rem;
  color: var(--muted);
  line-height: 1.45;
}

[data-react-route-map-panel="true"] .trip-stop-legend {
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  max-width: 100%;
  gap: 8px 12px;
  padding-top: 8px;
  border-top: 1px dashed var(--line);
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .trip-stop-legend {
  flex-wrap: wrap;
  gap: 4px 6px;
}

[data-react-route-map-panel="true"] .route-map-legend .trip-stop-legend {
  padding-top: 0;
  border-top: 0;
  align-items: center;
}

[data-react-route-map-panel="true"] .trip-stop-legend--map-inline {
  padding-top: 0;
  border-top: 0;
}

[data-react-route-map-panel="true"] .trip-stop-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--muted-strong);
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .trip-stop-legend__item {
  gap: 5px;
  font-size: 0.64rem;
}

[data-react-route-map-panel="true"] .trip-stop-legend__dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  box-shadow: 0 0 0 1px rgba(21, 37, 36, 0.14);
  background: var(--color-accent);
  flex: 0 0 auto;
}

[data-react-route-map-panel="true"] .route-map-legend[data-route-map-legend-compact="true"] .trip-stop-legend__dot {
  width: 10px;
  height: 10px;
}

[data-react-route-map-panel="true"] .trip-stop-legend__dot--start {
  background: var(--color-accent);
}

[data-react-route-map-panel="true"] .trip-stop-legend__dot--stop {
  background: #ffffff;
  border: 2px solid #12182a;
}

[data-react-route-map-panel="true"] .trip-stop-legend__dot--loading {
  background: var(--route-loading);
}

[data-react-route-map-panel="true"] .trip-stop-legend__dot--delivery {
  background: var(--route-delivery);
}

[data-react-route-map-panel="true"] .trip-stop-legend__dot--return {
  background: var(--color-accent);
}

[data-react-route-map-panel="true"] .trip-stop-legend__dot--warning {
  background: #d97706;
}

[data-react-route-map-panel="true"] .leaflet-container {
  font-family: "Plus Jakarta Sans", "Segoe UI", sans-serif;
}

[data-react-route-map-panel="true"][data-route-map-floating="true"] .leaflet-bottom.leaflet-right {
  bottom: 0.75rem;
  right: 4.5rem;
}

[data-react-route-map-panel="true"] .leaflet-tooltip.route-stop-tooltip {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: rgba(17, 24, 39, 0.94);
  box-shadow: 0 18px 38px rgba(10, 32, 37, 0.24);
  color: #f8fafc;
  font-family: "Plus Jakarta Sans", "Segoe UI", sans-serif;
  font-size: 0.74rem;
  font-weight: 600;
  line-height: 1.35;
  padding: 8px 10px;
}

[data-react-route-map-panel="true"] .leaflet-tooltip.route-stop-tooltip.leaflet-tooltip-top::before {
  border-top-color: rgba(17, 24, 39, 0.94);
}

@media (max-width: 720px) {
  [data-react-route-map-panel="true"] .route-map-legend__row {
    gap: 6px 10px;
  }

  [data-react-route-map-panel="true"] .leaflet-control-zoom {
    display: none;
  }

  [data-react-route-map-panel="true"] .route-map-legend__label--points {
    margin-left: 0;
  }

  [data-react-route-map-panel="true"] .dispatch-map-shell,
  [data-react-route-map-panel="true"] .route-map {
    height: 320px;
    min-height: 320px;
  }
}
